import { ContactRecord, InterestRecord, RiderRecord } from "./dynamoDBClient";
import { getValueByStage } from "@/lib/appStage";

export async function riderPost(record: RiderRecord) {
	await fetch("/api/rider", {
		method: "POST",
		body: JSON.stringify({ ...record }),
		headers: { "Content-Type": "application/json" }
	});
}

export async function interestPost(record: InterestRecord) {
	await fetch("/api/interest", {
		method: "POST",
		body: JSON.stringify({ ...record }),
		headers: { "Content-Type": "application/json" }
	});
}

export async function contactPost(record: ContactRecord) {
	const apiUrl = getValueByStage({
		dev: "https://dev.api.comms.londongrade.com/interest-email",
		prod: "https://api.comms.trackeros.co/interest-email",
		local: "https://dev.api.comms.londongrade.com/interest-email"
	});

	const response = await fetch(apiUrl, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			tenancyId: 1,
			senderEmail: record.email,
			senderFirstName: record.first_name,
			senderLastName: record.last_name,
			message: record.message,
			subject: record.inquiry_type || "Contact Form Submission",
			phone: record.phone,
			company: record.company,
			portfolioSize: record.portfolio_size,
			inquiryType: record.inquiry_type,
			urgency: record.urgency
		})
	});

	if (!response.ok) {
		const payload = (await response.json().catch(() => null)) as { error?: string } | null;
		throw new Error(payload?.error || "Could not submit your request.");
	}

	return response.json() as Promise<{ interestId: string; threadId: string }>;
}
